module.exports = __webpack_public_path__ + "static/media/odt.9191ffe8.png";